type Cue = {
    key: string,
    data: string
}

interface TrackCue extends TextTrackCue {
    value: Cue
}

export interface Tag {
    timestamp: number
}

export interface Metadata {
    value: Tag
}

export function setupMetadataManagement(
    track: TextTrack | null,
    restrictMetadata: boolean,
    metadataTypes: string[],
    emitMetadata: (metadata: Metadata) => void
): void {
    if (!track || track.kind !== 'metadata' || restrictMetadata) {
        return;
    }

    track.mode = 'hidden';

    track.oncuechange = () => {
        const activeCues = track.activeCues || [];

        for (const trackCue of activeCues) {
            const cue = (trackCue as TrackCue).value;

            if (!cue.data || cue.key !== 'TXXX') {
                return;
            }

            let tag;
            try {
                tag = JSON.parse(cue.data);
            } catch (e) {
                console.warn('[MetadataManagement] failed to parse cue data', cue.data);
                return;
            }

            const shouldEmitTag = metadataTypes.includes(tag.tag_id);

            if (shouldEmitTag) {
                console.log('[MetadataManagement] emitting', tag);
                delete tag.type; // deprecated
                delete tag.start; // deprecated
                delete tag.startBroadcast; // deprecated
                delete tag.stopBroadcast; // deprecated
                delete tag.data; // deprecated
                emitMetadata({ value: tag });
            }
        }
    };
}
